export default "__VITE_ASSET__b95b9fd2__"